import axios from 'axios';
import Session from './session';
import moment from "moment-timezone";

/* =========================
   AXIOS INSTANCE (Recommended)
========================= */
const api = axios.create({
  timeout: 3600000,
});

/* =========================
   REQUEST INTERCEPTOR
========================= */
api.interceptors.request.use(
  (config) => {
    const token = Session.getSession('token');
    const user = Session.getSession('user');
    const method = (config.method || 'get').toLowerCase();

    const params = { ...(config.params || {}) };

    if (user && user._id) {
      if (["get", "delete"].includes(method)) {
        params.loginId = user._id;
        params.limit = params.limit ?? 50;
      }

      if (["post", "put", "patch"].includes(method)) {
        params.loginId = user._id;
      }
    }

    config.params = params;
    config.headers = config.headers || {};

    config.headers['Accept'] = 'application/json';
    config.headers['IPADDRESS'] = window.newip || window.userip || '';
    config.headers['timezone'] = moment.tz.guess() || '';

    if (!(config.data instanceof FormData)) {
      config.headers['Content-Type'] = 'application/json';
    } else {
      delete config.headers['Content-Type'];
    }

    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

/* =========================
   RESPONSE INTERCEPTOR
========================= */
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (!error.response && error.message === 'Network Error') {
      alert("Couldn't connect to server");
      return Promise.reject(error);
    }

    console.error("API Error:", error);

    return Promise.reject(error);
  }
);

/* =========================
   HTTP WRAPPER
========================= */
export default class HTTP {
  static Request(method, url, data = {}, extraConfig = {}) {
    method = method.toLowerCase();

    const config = {
      method,
      url,
      ...extraConfig,
    };

    if (method === 'get' || method === 'delete') {
      config.params = { ...(extraConfig.params || {}), ...data };
    } else {
      config.data = data;
    }

    return api(config).then((res) => res.data);
  }
}